import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { WalletApi } from 'src/app/shared/apis/wallet.api';
import { ToastService } from 'src/app/shared/service/toast.service';
import { BonusApi } from '../../apis/bonus.api';
import { LaterConfigInfo, LaterPageInfo } from '../../interfaces/bonus.interface';
import { PaginatorState } from '../paginator/paginator.module';
import { AppService } from './../../../app.service';
import { LocaleService } from './../../service/locale.service';

@Component({
  selector: 'app-led-popup',
  templateUrl: './led-popup.component.html',
  styleUrls: ['./led-popup.component.scss'],
})
export class LedPopupComponent implements OnInit {
  constructor(
    private dialogRef: MatDialogRef<LedPopupComponent>,
    @Inject(MAT_DIALOG_DATA) private data: any,
    private bonusApi: BonusApi,
    private walletApi: WalletApi,
    private toast: ToastService,
    private appService: AppService,
    private localeService: LocaleService,
  ) {}
  loading = false;
  /** 分页 */
  paginator: PaginatorState = {
    page: 1,
    pageSize: 10,
    total: 0,
  };
  /** LED解锁弹窗configinfo */
  laterConfigInfo!: LaterConfigInfo;
  /** LED历史纪录 */
  laterPageInfo: Array<LaterPageInfo> = [];
  /** 是否显示 如何解锁介绍(class="page-2") */
  showPage2 = false;

  ngOnInit(): void {
    this.showPage2 = this.data?.showPage2 || false;
    this.loadData();
  }

  /**
   * 获取LED弹窗资料与LED纪录（同一支api）
   */
  loadData() {
    this.loading = true;
    const param = {
      pageIndex: this.paginator.page,
      pageSize: this.paginator.pageSize,
    };
    this.bonusApi.getLater(param).subscribe(data => {
      this.loading = false;
      this.laterConfigInfo = data.configInfo;
      this.laterPageInfo = data.list || [];
      this.paginator.total = data.total;
      console.log('123', this.laterConfigInfo);
    });
  }

  /**
   * 領取led
   *
   * @param amonut
   */
  receiveLed(amonut: number) {
    if (Number(this.laterConfigInfo?.lockedAmount || 0) < Number(this.laterConfigInfo?.minAmount || 0)) {
      this.toast.show({
        message: `${this.localeService.getValue('minimum_amount_for_withdrawal')}: ${this.laterConfigInfo?.minAmount || 0} LED`,
        type: 'fail',
      });
      return;
    }
    this.walletApi.receiveLed(amonut).subscribe(x => {
      if (x) {
        this.toast.show({ message: this.localeService.getValue('claim_success'), type: 'success' });
        //手动更新余额
        this.appService.assetChanges$.next({ related: 'Wallet' });
        this.close();
      } else {
        this.toast.show({ message: this.localeService.getValue('claim_failed'), type: 'fail' });
      }
    });
  }

  /**
   * 关闭弹窗
   */
  close() {
    // this.dialogRef.close();
    this.appService.closeDialogInTransition(this.dialogRef);
  }
}
